<template>
  <div ref="layout" class="page-query">
    <TableQuery title="营销单元刷新批导" @search="queryData" @reset="resetQuery">
      <el-form inline class="form" size="mini" label-width="100px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="批次号">
              <el-input v-model="conditions.BATCH_NUMBER" placeholder="请输入" type="text" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="导入类型">
              <el-select v-model="conditions.BATCH_TYP" clearable>
                <el-option v-for="item in selectDataOptions['A0053']" :key="item.id" :value="item.value" :label="item.name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="附件名称">
              <el-input v-model="conditions.FILE_NAME" placeholder="请输入" type="text" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="批导人">
              <el-input v-model="conditions.BATCH_NAME" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="批导日期">
              <el-date-picker v-model="conditions.DATUM" type="date" value-format="yyyy-MM-dd" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="批导处理状态">
              <el-select
                v-model="conditions.BATCH_STATUS"
                placeholder="请选择"
                clearable
              >
                <el-option v-for="item in selectDataOptions['A0030']" :key="item.id" :value="item.value" :label="item.name" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </TableQuery>

    <div class="table-container">
      <TableCommon
        title="结果清单"
        :custome-config="() => vxeShowCustom('xTable')"
        export-all
        export-page
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
        @exportExcel="exportExcel"
      >
        <template #button>
          <table-button name="upload" tip="批导类型选择" @click="exportTypeSelect('import')" />
          <table-button name="download" tip="批导模板下载" @click="exportTypeSelect('download')" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #batch_number="{ row }">
            <span class="blue" @click="toDetail(row)">{{ row.batch_number }}</span>
          </template>
          <template #file_name="{ row }">
            <span class="blue" @click="downLoadFile(row)">{{ row.file_name }}</span>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitleType"
      :visible.sync="showTypeDialog"
      width="500px"
      :append-to-body="true"
    >
      <div v-if="showTypeDialog" class="type-wrapper">
        <vxe-grid
          ref="xTable2"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          max-height="500"
          align="center"
          size="mini"
          :edit-config="{ trigger: 'click', mode: 'row', activeMethod: activeRowMethod }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :columns="typeGridOptions.columns"
          :data="selectDataOptions['A0053']"
        >
          <template #batch_number="{ row }">
            <span class="blue" @click="toDetail(row)">{{ row.batch_number }}</span>
          </template>
        </vxe-grid>
      </div>
    </el-dialog>

    <!-- 页面通用弹窗情况 -->
    <el-dialog
      title="批导明细"
      :visible.sync="showPageEditDialog"
      fullscreen
      :append-to-body="true"
    >
      <import-detail
        v-if="showPageEditDialog"
        :row-data="currentRow"
        @close="closePageEditDialog"
      />
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { filterSapParams } from '@/utils/index'
import { getSaleCenterUpdateList, apiSaleCenterImport } from '@/api/sap/system-settings'
import { frontExport, exportAll, sapDownloadFile } from '@/utils/frontExport'
import {
  apiExportExcelTemplate,
  apiExcelImport,
  apiGetExcelImportData,
  apiSaveExcelImportData
} from '@/api/common'
import { getToken } from '@/utils/auth'
import { DOWNLOAD_API } from '@/api/baseUrl'
import importDetail from './importDetail.vue'

const templateCode = {
  'V001': 'salePlanYxdyImport',
  'V002': 'saleOrdeYxdyImport',
  'V003': 'ticketingNoticeYxdyImport',
  'V004': 'materialPlanYxdyImport',
  'V005': 'generatePlanYxdyImport',
  'V006': 'contractYxdyImport'
}

export default {
  components: {
    importDetail
  },
  data() {
    return {
      showDialogType: '',
      mode: 'import',
      showTypeDialog: false,
      importConfig: {
        templateCode: '',
        batchNumber: ''
      },
      showPageEditDialog: false,
      currentRow: {},
      selectDataOptions: {},
      conditions: {
        BATCH_NUMBER: '',
        BATCH_TYP: '',
        FILE_NAME: '',
        BATCH_NAME: '',
        DATUM: '',
        BATCH_STATUS: ''
      },
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      loading: false,
      gridOptions: {
        columns: [
          {
            field: 'batch_number',
            title: '批次号',
            slots: {
              default: 'batch_number'
            }
          },
          { field: 'file_name', title: '附件名称', slots: {
            default: 'file_name'
          }},
          { field: 'batch_type_text', title: '批导类型' },
          { field: 'batch_status_text', title: '批导处理状态' },
          { field: 'batch_name', title: '批导人' },
          { field: 'mdate', title: '批导日期' },
          { field: 'mtime', title: '批导时间' }
        ],
        data: []
      },
      typeGridOptions: {
        columns: [
          { field: 'value', title: '导入模板编码', editRender: {}, width: 150 },
          { field: 'name', title: '导入模板描述', editRender: {}, width: '' }
        ],
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['role']),
    dialogTitleType() {
      return {
        import: '批导类型选择',
        download: '批导模板选择'
      }[this.mode]
    }
  },
  created() {
    // 导入类型
    this.getSelectDictDataOrigin('A0053')
    // 批导处理状态
    this.getSelectDictDataOrigin('A0030')
    this.queryData()
  },
  methods: {
    toDetail(row) {
      this.currentRow = row
      this.showPageEditDialog = true
    },
    downLoadFile(row) {
      sapDownloadFile(row.file_data, row.file_name)
    },
    closePageEditDialog() {
      this.showPageEditDialog = false
      this.queryData()
    },
    exportTypeSelect(mode) {
      this.mode = mode
      this.showTypeDialog = true
    },
    activeRowMethod({ row }) {
      // console.log('row, rowIndex', row, rowIndex)
      this.showTypeDialog = false
      if (this.mode === 'download') {
        this.downloadTemplate(templateCode[row.value], `${row.name}导入模版`)
      } else {
        this.handleImportExcel(row.value)
      }
    },
    // 查询
    async queryData(page) {
      page && (this.pagination.page = page)
      const params = { ...filterSapParams(this.conditions), ...this.pagination }

      params.mv_bp = this.role.USER_BP
      params.role = this.role.ROLE
      const { data, total } = await getSaleCenterUpdateList(params)
      this.gridOptions.data = data
      this.pagination.totalCount = total - 0
    },
    // 导出全部 导出本页
    async exportExcel(type) {
      if (!this.gridOptions.data.length) {
        await this.queryData()
      }
      // 导出本页
      if (type === 'page') {
        frontExport(this.gridOptions.columns, this.gridOptions.data, '营销单元刷新批导')
      } else {
        // 导出全部
        const params = {
          ...filterSapParams(this.conditions),
          mv_bp: this.role.USER_BP,
          role: this.role.ROLE,
          ...this.pagination
        }
        const options = {
          columns: this.gridOptions.columns,
          resk: 'data',
          fileName: '营销单元刷新批导'
        }
        exportAll(getSaleCenterUpdateList, params, options)
      }
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 处理分页事件table
    handleTablePaginationChange(pageParams) {
      this.pagination = { ...this.pagination, ...pageParams }
      this.queryData()
    },
    // 模板下崽
    async downloadTemplate(tem, fileName) {
      const res = await apiExportExcelTemplate(tem)

      if (res?.status !== 0) {
        return
      }

      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data.file
      }&authToken=${getToken()}&fileName=${fileName}`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.target = '_blank'
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    async uploadFile(file, type, head) {
      const _this = this
      const reader = new FileReader()
      reader.readAsArrayBuffer(file)
      var strArr = []
      reader.onload = function() {
        var unitArray = new Uint8Array(this.result)
        for (var i = 0; i < unitArray.length; i++) {
          var u_arr16 = unitArray[i].toString(16).toLocaleUpperCase()
          if (u_arr16.length < 2) {
            u_arr16 = '0' + u_arr16
          }
          strArr.push(u_arr16)
        }

        strArr = strArr.join('')

        const HEAD = [
          {
            'OBJPAR_ID': '',
            'SAL_CENTER_NAME': '',
            'SAL_CENTER': ''
          }
        ]
        if (head && head.length > 0) {
          HEAD[0].OBJPAR_ID = head[0].objparId
          HEAD[0].SAL_CENTER_NAME = head[0].salCenterName
          HEAD[0].SAL_CENTER = head[0].salCenter
        }

        const params = {
          BATCH_TYPE: type,
          FILENAME: file.name,
          MIMETYPE: file.type,
          FILEDATA: strArr,
          EXTENSION: 'xlsx',
          USER_BP: _this.role.USER_BP,
          HEAD
        }
        apiSaleCenterImport(params).then(res => {
          _this.currentRow.batch_number = res.DATA
          _this.showPageEditDialog = true
        })
      }
    },
    parseTime(date) {
      return this.$utilsCommon.parseTime(new Date(date).getTime(), '{y}-{m}-{d}')
    },
    // 导入excel
    async handleImportExcel(type) {
      this.$refs.xTable
        .readFile({
          types: ['xlsx']
        })
        .then(async({ file }) => {
          const formData = new FormData()
          formData.append('file', file)
          const params = {
            formData,
            templateCode: templateCode[type]
          }
          const res = await apiExcelImport(params)
          if (res?.status === 1) {
            this.importConfig.batchNumber = res.data
            this.importConfig.templateCode = templateCode[type]
            this.handleQueryImportExcel(file, type)
          }
        })
    },
    // 查询导入excel数据 TODO 查询无数据  导致无法填写HEAD信息
    async handleQueryImportExcel(file, type) {
      const { page, pagesize } = this.pagination
      const params = { ...this.importConfig, page, pagesize }
      const res = await apiGetExcelImportData(params)
      this.uploadFile(file, type, res.data.Rows)
      console.log(res.data.Rows)
    },
    resetQuery() {
      this.conditions = {
        BATCH_NUMBER: '',
        BATCH_TYP: '',
        FILE_NAME: '',
        BATCH_NAME: '',
        DATUM: '',
        BATCH_STATUS: ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__body {
  min-height: 200px;
}
.type-wrapper {
  margin-bottom: 20px;
}
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/system-manage/saleCenterUpdate.vue